export interface ITabContentMethod extends Indexable {
  prev?: () => void;
  next?: () => void;
  move?: () => void;
  [key: string]: unknown;
}

export function withTabContnet<TProps extends object>(
  WrappedComponent: React.ComponentType<TProps & ITabContentMethod>,
  tabMethods: ITabContentMethod
) {
  const ComponetWithTabContent = (props: TProps) => {
    return <WrappedComponent {...props} {...tabMethods} />;
  };

  const wrappedName = WrappedComponent.displayName || "Component";
  ComponetWithTabContent.displayName = `withTabContent${wrappedName}`;

  return ComponetWithTabContent;
}
